var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTreeStructure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 37,
    viewBox: "0 0 42 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8438 12.7188H3.03125C2.16831 12.7188 1.46875 13.4183 1.46875 14.2812V22.0938C1.46875 22.9567 2.16831 23.6562 3.03125 23.6562H10.8438C11.7067 23.6562 12.4062 22.9567 12.4062 22.0938V14.2812C12.4062 13.4183 11.7067 12.7188 10.8438 12.7188Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9688 1H29.5938C28.7308 1 28.0312 1.69956 28.0312 2.5625V11.9375C28.0312 12.8004 28.7308 13.5 29.5938 13.5H38.9688C39.8317 13.5 40.5312 12.8004 40.5312 11.9375V2.5625C40.5312 1.69956 39.8317 1 38.9688 1Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9688 22.875H29.5938C28.7308 22.875 28.0312 23.5746 28.0312 24.4375V33.8125C28.0312 34.6754 28.7308 35.375 29.5938 35.375H38.9688C39.8317 35.375 40.5312 34.6754 40.5312 33.8125V24.4375C40.5312 23.5746 39.8317 22.875 38.9688 22.875Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4062 18.1875H20.2188",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0313 29.125H24.9063C24.29 29.1276 23.6793 29.0081 23.1094 28.7735C22.5395 28.5388 22.0218 28.1937 21.586 27.7579C21.1502 27.3221 20.805 26.8043 20.5703 26.2344C20.3357 25.6645 20.2162 25.0538 20.2188 24.4375V11.9375C20.2162 11.3212 20.3357 10.7105 20.5703 10.1407C20.805 9.57078 21.1502 9.05301 21.586 8.61722C22.0218 8.18143 22.5395 7.83625 23.1094 7.60159C23.6793 7.36694 24.29 7.24746 24.9063 7.25004H28.0313",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeStructure);
export default __webpack_public_path__ + "static/media/TreeStructure.f28630de82089d58be89d64f7ad9f955.svg";
export { ForwardRef as ReactComponent };